import { render, staticRenderFns } from "./gearbox-oil-poster.vue?vue&type=template&id=e2606cf8&scoped=true&"
import script from "./gearbox-oil-poster.vue?vue&type=script&lang=js&"
export * from "./gearbox-oil-poster.vue?vue&type=script&lang=js&"
import style0 from "./gearbox-oil-poster.vue?vue&type=style&index=0&id=e2606cf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2606cf8",
  null
  
)

export default component.exports